import React from 'react';
import { CheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { PriceBlock } from '../PriceBlock';
import { HERO_MOCKUP, OFFER_ITEMS, PRODUCT } from '../../data/catio';

/**
 * First price reveal. The hero CTA scrolls here (#offer).
 * This CTA — unlike the hero one — opens the real checkout.
 * `#offer-price` and `#offer-cta` drive the mobile sticky bar.
 */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-title" className="bg-ink py-12 sm:py-20" data-id="element-211" data-mp="1q81ylhi0aoy">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-8" data-id="element-212" data-mp="3sw9gx54l3ofv">
        <SectionHeading id="offer-title" tone="dark" align="center" eyebrow="The complete collection" title="Get the Complete CATIO READY™ Collection" data-id="element-213" data-mp="3suop3n9nmjlp" />

        <div className="mt-8 overflow-hidden rounded-[22px] bg-paper shadow-[0_40px_80px_-40px_rgba(0,0,0,0.8)] sm:mt-10 lg:grid lg:grid-cols-[1fr_1fr]" data-id="element-214" data-mp="3j0fzp8fx76rr">
          <div className="flex items-center justify-center border-b border-line bg-stone px-4 pb-4 pt-6 lg:border-b-0 lg:border-r lg:px-8 lg:py-10" data-id="element-215" data-mp="1ar8rerz1nl9o">
            <img src={HERO_MOCKUP.src} alt={HERO_MOCKUP.alt} width={HERO_MOCKUP.width} height={HERO_MOCKUP.height} loading="lazy" decoding="async" className="h-[230px] w-auto max-w-full object-contain drop-shadow-[0_18px_26px_rgba(28,31,28,0.18)] sm:h-[300px] lg:h-auto lg:max-h-[480px]" data-id="element-216" data-mp="10tuolv61muzu" />
          </div>

          <div className="px-5 pb-7 pt-6 sm:px-10 sm:pb-10 sm:pt-9" data-id="element-217" data-mp="1kid4fm55sw1v">
            <p className="wordmark text-[1.7rem] text-ink" data-id="element-218" data-mp="1kk6bv3nljkax">
              Catio <span className="text-ember" data-id="element-219" data-mp="1ohuaohsetx83">Ready</span>™
            </p>
            <p className="mt-1.5 text-[0.92rem] text-graphite" data-id="element-220" data-mp="92f0txsr3281">{PRODUCT.descriptor}</p>

            <ul className="mt-5 grid gap-2.5" data-id="element-221" data-mp="d4rv9q21rdpi">
              {OFFER_ITEMS.map(item => {
              const free = item.includes('FREE');
              return <li key={item} className="flex items-center gap-3 text-[1rem] font-semibold text-ink" data-id="element-222" data-mp="2fsrshr7vdgzn">
                    <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${free ? 'border border-ember text-ember' : 'bg-ink text-cream'}`} aria-hidden data-id="element-223" data-mp="25zjd4jji7f9a">
                      <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-224" data-mp="1s0jqtijgrcga" />
                    </span>
                    {free ? <span data-id="element-225" data-mp="1n4cijj3lhov6">
                        {item.replace(' FREE', '')} <span className="text-ember" data-id="element-226" data-mp="1i489uf8xhyfi">FREE</span>
                      </span> : item}
                  </li>;
            })}
            </ul>

            <div className="mt-6 border-t border-line pt-6" data-id="element-227" data-mp="3cf3gvd4gt5g6">
              <PriceBlock id="offer-price" data-id="element-228" data-mp="3kx5k8zqaxtrh" />
            </div>

            <CTAButton id="offer-cta" label="Get CATIO READY™ Now" size="lg" className="mt-6 w-full" data-id="element-229" data-mp="3ozk0rd6i0hfl" />

            <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[0.84rem] text-graphite" data-id="element-230" data-mp="3tslh7pmcsp1a">
              <li className="flex items-center gap-1.5" data-id="element-231" data-mp="31zcgxwbrnhtk">
                <LockIcon className="h-3.5 w-3.5 text-wood" aria-hidden data-id="element-232" data-mp="320x9xhifmspb" /> Secure checkout
              </li>
              <li className="flex items-center gap-1.5" data-id="element-233" data-mp="3617p9ks46vgu">
                <ZapIcon className="h-3.5 w-3.5 text-wood" aria-hidden data-id="element-234" data-mp="3azrblmame99q" /> Instant digital access
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}